module.exports = __webpack_public_path__ + "static/toutiao-c831fb8c71ca6a099d48aa8e43550f0a.png";